import { List, ListItemButton, ListItemText, Paper } from "@mui/material";
import { useState } from "react";
import Timeoff from "../../models/Timeoff";
import OpsStringUtils from "../../utils/OpsStringUtils";
import TimeOffUtils from "../../utils/TimeOffUtils";
import TimeoffViewDialog from "../TimeOffViewDialog";
import timeOffIcon from "../../img/icons/time_off.svg"
import OpsPanel from "../OpsPanel";

interface Props {
  rows: Timeoff[];
}

const RequestedTimeOff = ({ rows }: Props) => {
  const [viewTimeoff, setViewTimeoff] = useState<Timeoff | undefined>();

  const closeViewDialog = () => {
    setViewTimeoff(undefined);
  };

  return (
    <>
      {rows.length > 0 ? (
      <OpsPanel
      title="My Timeoffs"
      icon={timeOffIcon}
      actionsRequired={false}
      >
        <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
          <List disablePadding>
            {rows.map((row, index) => (
              <ListItemButton alignItems="flex-start" disableGutters dense>
                <ListItemText
                  secondary={TimeOffUtils.getTimeoffDetails(row) + " - " + OpsStringUtils.capitalize(row.status)}
                  onClick={() => setViewTimeoff(row)}
                  primaryTypographyProps={{ fontWeight: "bold" }}
                />
              </ListItemButton>
              ))}
          </List>
        </Paper>
      </OpsPanel>
      )       
      : null}
      {viewTimeoff && <TimeoffViewDialog viewTimeoff={viewTimeoff} selectedFiles={viewTimeoff!.documentation} onClose={closeViewDialog} />}
    </>
  );
};

export default RequestedTimeOff;
